import VenueLogo from './venueLogo';
export default VenueLogo;
